import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseISO, differenceInDays } from 'date-fns';
import { getReflex } from '../../api/api';
import FlatList from 'flatlist-react';
import { faFilter, faCog, faPlus } from '@fortawesome/free-solid-svg-icons';
import DrawerNavigation from '../../utils/DrawerNavigation.js';
import { useMediaQuery } from 'react-responsive';
import myinventory from '../../assets/myinventory_mobile_logo.svg';
import myinventoryIcone from '../../assets/myinventory-icone.svg';
import atos from '../../assets/atos-logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../styles/Buttons.css';
import '../../styles/Texts.css';
import '../../styles/Utils.css';
import '../../styles/Alinhamento.css';
import '../../styles/Imagens.css';

function Agendamentos() {
    const navigate = useNavigate();
    const location = useLocation();
    const [equipamentos, setequipamentos] = useState([]);
    const user = location.state?.user || localStorage.getItem('user');
    const isBigScreen = useMediaQuery({ query: '(min-width: 481px)' });
    const [filterValue, setFilterValue] = useState('all');
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [visibleFieldsMenuOpen, setVisibleFieldsMenuOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [visibleFields, setVisibleFields] = useState({
        numero_serie: true,
        apellidos_titular_nombre_titular: false,
        modelo: false,
        tipo_ci_tipo_puesto: false,
        oficina_zona_taller: false,
        centro_produccion: false,
        estado: true,
        utilizacion: false,
        grupo: false,        
        numero_inventario: false,     
    
    });

    const toggleFieldVisibility = (field) => {
        setVisibleFields(prevState => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    useEffect(() => {
        if (user === undefined) {
            navigate('/');
            // eslint-disable-line react-hooks/exhaustive-deps  
        }
    },);
    const [searchValue, setSearchValue] = useState("");

    const handleFilterChange = (value) => {
        setFilterValue(value);
        setFilterMenuOpen(false);
    };

    const filtered = equipamentos.filter(equipamentos => {
        if (filterValue === 'true') return equipamentos.encontrado === true;
        if (filterValue === 'false') return equipamentos.encontrado === false;
        return true;  // 'all'
    });

    
    const fetchreflex = async () => {        
        const response = await getReflex();        
        const equipamento = response.map((r) => ({
            ...r.fields,
            pk: r.pk
        }));
        setequipamentos(equipamento);
        localStorage.setItem('equipamentosR', JSON.stringify(equipamento));
        setLoading(false);
    };

    useEffect(() => {
        const storedEquipamentosR = localStorage.getItem('equipamentosR');
        if (storedEquipamentosR) {
            setequipamentos(JSON.parse(storedEquipamentosR));
            setLoading(false);
        } else {
            fetchreflex();
        }
    }, []);

    const renderItem = (equipamentos, index) => (
        <div
            className='div-perfis-de-usuario centralizar'
            style={{ backgroundColor: differenceInDays(new Date(), parseISO(equipamentos.alterado_em)) <= 30 ? 'green' : 'rgb(0, 103, 155)' }}
            onClick={() => navigate('/ReflexEditarEquipamentos', { state: { user: user, equipamentos: equipamentos } })}
            key={equipamentos.numero_serie}
        >
            <div className='left'>
                {visibleFields.numero_serie && <p>{equipamentos.numero_serie}</p>}
                {visibleFields.apellidos_titular_nombre_titular && <p>{equipamentos.apellidos_titular_nombre_titular}</p>}
                {visibleFields.modelo && <p>{equipamentos.modelo}</p>}
                {visibleFields.categoria_modelo && <p>{equipamentos.categoria_modelo}</p>}
                {visibleFields.oficina_zona_taller && <p>{equipamentos.oficina_zona_taller}</p>}
                {visibleFields.centro_produccion && <p>{equipamentos.centro_produccion}</p>}
                {visibleFields.estado && <p>{equipamentos.estado}</p>}
                {visibleFields.utilizacion && <p>{equipamentos.utilizacion}</p>}
                {visibleFields.grupo && <p>{equipamentos.grupo}</p>}                
                {visibleFields.numero_inventario && <p>{equipamentos.numero_inventario}</p>}
                
            </div>
            <div className='right'>
                <p>{equipamentos.hostname}</p>
                <p> {equipamentos.centro_produccion}</p>
            </div>

        </div>
    );

    if (loading) {
        return <div>Carregando equipamentos...</div>;
    }

    return (
        <>
            

            <main>
                <p className="texto-principal-da-pagina">Selecione o equipamento para editar</p>
                <form
                    style={{ display: 'flex', position: 'relative', flexDirection: 'column', alignItems: 'center' }}

                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FontAwesomeIcon 
                            icon={faCog} 
                            style={{ marginRight: '10px', cursor: 'pointer' }} 
                            onClick={() => setVisibleFieldsMenuOpen(!visibleFieldsMenuOpen)}
                        />
                        {visibleFieldsMenuOpen && (
                            <div style={{ position: 'absolute', top: '30px', left: '0', background: 'white', border: '1px solid #ccc', borderRadius: '5px', zIndex: 1 }}>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.numero_serie}
                                        onChange={() => toggleFieldVisibility('numero_serie')}
                                    />
                                    Número de Série
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.apellidos_titular_nombre_titular}
                                        onChange={() => toggleFieldVisibility('apellidos_titular_nombre_titular')}
                                    />
                                    NOMBRE TITULAR
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.modelo}
                                        onChange={() => toggleFieldVisibility('modelo')}
                                    />
                                    MODELO
                                </label> 
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.tipo_ci_tipo_puesto}
                                        onChange={() => toggleFieldVisibility('tipo_ci_tipo_puesto')}
                                    />
                                    TIPO CI/TIPO DE PUESTO
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.oficina_zona_taller}
                                        onChange={() => toggleFieldVisibility('oficina_zona_taller')}
                                    />
                                    OFICINA / ZONA TALLER
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.centro_produccion}
                                        onChange={() => toggleFieldVisibility('centro_produccion')}
                                    />
                                    CENTRO DE PRODUCCION
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.estado}
                                        onChange={() => toggleFieldVisibility('estado')}
                                    />
                                    ESTADO
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.utilizacion}
                                        onChange={() => toggleFieldVisibility('utilizacion')}
                                    />
                                    UTILIZACIÓN
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.grupo}
                                        onChange={() => toggleFieldVisibility('grupo')}
                                    />
                                    Grupo
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.numero_inventario}
                                        onChange={() => toggleFieldVisibility('numero_inventario')}
                                    />
                                    NUMERO DE INVENTARIO
                                </label>                                                                          
                                
                            </div>
                        )}                        
                        <input
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value.toLocaleLowerCase())}
                            className="input-login"
                            type="text"
                            id="nickName"
                            placeholder="  Pesquisar equipamentos..."
                        />
                        <FontAwesomeIcon 
                            icon={faFilter} 
                            style={{ marginLeft: '20px', cursor: 'pointer' }} 
                            onClick={() => setFilterMenuOpen(!filterMenuOpen)} 
                        />
                        {filterMenuOpen && (
                            <div style={{ position: 'absolute', top: '30px', right: '0', background: 'white', border: '1px solid #ccc', borderRadius: '5px', zIndex: 1 }}>
                                <div onClick={() => handleFilterChange('all')} style={{ padding: '5px 10px', cursor: 'pointer' }}>Todos</div>
                                <div onClick={() => handleFilterChange('true')} style={{ padding: '5px 10px', cursor: 'pointer' }}>Encontrados</div>
                                <div onClick={() => handleFilterChange('false')} style={{ padding: '5px 10px', cursor: 'pointer' }}>Não encontrado</div>
                            </div>
                        )}
                    </div>
                </form>
                
                <FlatList
                    list={filtered}
                    searchBy={['hostname',	'numero_serie',	'fan',	'modelo',	'oficina_zona_taller',	'pilar',	'apellidos_titular_nombre_titular',	'grupo',	'windows_build',	'estado',	'utilizacion',	'tipo_ci_tipo_puesto',	'direccion_ip',	'na',	'centro_produccion',	'comentarios',	'fecha_creacion',	'verificacao_etiqueta',	'respostas_psav3',	'tipo_uso',	'numero_inventario',	'idade_meses',	'encontrado',	'alterado_em']}
                    searchTerm={searchValue}
                    searchCaseInsensitive
                    renderItem={renderItem}
                    renderWhenEmpty={() => <div>Não há equipamentos cadastrados!</div>}
                />
                <FontAwesomeIcon 
                    icon={faPlus} 
                    style={{  fontSize: '40px',marginRight: '10px', cursor: 'pointer' }}  
                    onClick={() => navigate('/Reflex_CriarEquipamentos', { state: { user } })}
                />

                
                <footer>
                    <img src={atos} className='footer-alinhamento Atos-logo' alt='logo atos'></img>
                </footer>

            </main>
        </>
    );
}

export default Agendamentos;
